import * as R from 'remeda';
import type { CascaderOption } from '../helpers/types';

/**
 * 検索結果の型（パス情報を含む）
 */
export type SearchResult = {
  option: CascaderOption;
  path: string[];
  pathLabels: string[];
};

/**
 * 全オプションをフラットなリストに変換して検索
 */
export const searchOptionsFlat = (
  opts: CascaderOption[],
  query: string,
  parentPath: string[] = [],
  parentLabels: string[] = [],
): SearchResult[] => {
  if (!query) return [];

  const lowerQuery = query.toLowerCase();

  return R.flatMap(opts, (opt) => {
    const currentPath = [...parentPath, opt.value];
    const currentLabels = [...parentLabels, opt.label];

    const selfMatch: SearchResult[] = opt.label.toLowerCase().includes(lowerQuery)
      ? [{ option: opt, path: currentPath, pathLabels: currentLabels }]
      : [];

    const childMatches = opt.children?.length
      ? searchOptionsFlat(opt.children, query, currentPath, currentLabels)
      : [];

    return [...selfMatch, ...childMatches];
  });
};

/**
 * 検索フィルタリング（従来の階層構造を維持）
 */
export const searchOptions = (opts: CascaderOption[], query: string): CascaderOption[] => {
  if (!query) return opts;

  const lowerQuery = query.toLowerCase();

  return R.pipe(
    opts,
    R.map((opt) => {
      const matches = opt.label.toLowerCase().includes(lowerQuery);
      const filteredChildren = opt.children ? searchOptions(opt.children, query) : [];

      if (matches || filteredChildren.length > 0) {
        return {
          ...opt,
          children: filteredChildren.length > 0 ? filteredChildren : opt.children,
        };
      }
      return null;
    }),
    R.filter(R.isNonNullish),
  );
};
